import App from "../../core/facade";
import mediator from "libs/mediator";

App.on("authors_index:init", function() {
  App.log("Authors page init");
  mediator.trigger("showmore");
});
